import { styled } from "styled-components";

export const ContentsSlideContainer = styled.div`
  position: relative;
`;

export const EducationSlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const EducationSlideContainer = styled.ul``;

export const EducationSlideImgWrap = styled.div`
  width: 100%;
  height: 660px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #efefef;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media all and (max-width: 1024px) {
    height: 64.453vw;
  }
  @media all and (max-width: 768px) {
    height: 75vw;
  }
`;

export const EducationSlidePrevButton = styled.button`
  position: absolute;
  top: 50%;
  left: 16px;
  z-index: 20;
  transform: translateY(-50%);
  appearance: none;
  width: 56px;
  height: 56px;
  background: rgba(0, 0, 0, 0.6);
  border: 0 none;
  cursor: pointer;
  padding: 0;
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 768px) {
    width: 5.469vw;
    height: 5.469vw;
    img {
      width: 4.427vw;
      height: 4.427vw;
    }
  }
`;
export const EducationSlideNextButton = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  z-index: 20;
  transform: translateY(-50%);
  appearance: none;
  width: 56px;
  height: 56px;
  background: rgba(0, 0, 0, 0.6);
  border: 0 none;
  cursor: pointer;
  padding: 0;
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 768px) {
    width: 5.469vw;
    height: 5.469vw;
    img {
      width: 4.427vw;
      height: 4.427vw;
    }
  }
`;
